import get$1 from 'lodash/get';

function getDOMEventValue (event) {
  var type = get$1(event, 'target.attributes.type.value');
  return ['checkbox', 'radio'].indexOf(type) === -1 ? get$1(event, 'target.value') : get$1(event, 'target.checked');
}

export default getDOMEventValue;
